import { useConfigStore } from '@/stores/configStore';
import axios, { type AxiosInstance } from 'axios';
import { applyApiUrlInterceptor } from './interceptors/apiUrlInterceptor';
import { applyErrorInterceptor } from './interceptors/errorInterceptor';
import {
  applyAddRequestToStoreInterceptor,
  applyRemoveRequestFromStoreInterceptor
} from './interceptors/requestStoreInterceptor';
import { applyTokenInterceptor } from './interceptors/tokenInteceptor';

function createAxiosInstance() {
  const { apiRoot } = useConfigStore();

  const httpClient = axios.create({
    baseURL: apiRoot || '',
    headers: {
      'Content-type': 'application/json'
    }
  });

  applyApiUrlInterceptor(httpClient);
  applyTokenInterceptor(httpClient);
  applyAddRequestToStoreInterceptor(httpClient);
  applyRemoveRequestFromStoreInterceptor(httpClient);
  applyErrorInterceptor(httpClient);

  return httpClient;
}

let instance: AxiosInstance;

export default function getAxiosInstance() {
  if (!instance) {
    instance = createAxiosInstance();
  }

  return instance;
}
